import { getOptionalSelectedCompanyId } from "../utils/companyContext";

export type PermissionAction = "view" | "create" | "edit" | "delete" | "approve";

export type RoutePermission = {
  prefix: string;
  module: string;
  action?: PermissionAction;
};

const rules: RoutePermission[] = [
  { prefix: "/", module: "dashboard" },
  { prefix: "/dashboard", module: "dashboard" },
  { prefix: "/alerts", module: "dashboard" },

  { prefix: "/master/bp", module: "business_partners" },
  { prefix: "/pricing", module: "business_partners" },

  { prefix: "/inventory/items", module: "item_master" },
  { prefix: "/inventory/warehouse", module: "warehouse" },
  { prefix: "/inventory/grn", module: "stock_in" },
  { prefix: "/inventory/ledger", module: "stock_ledger" },
  { prefix: "/inventory/gi", module: "stock_ledger" },
  { prefix: "/inventory/stock-valuation", module: "stock_ledger" },
  { prefix: "/inventory/physical-count", module: "stock_ledger" },
  { prefix: "/inventory/stock-transfer", module: "stock_ledger" },
  { prefix: "/inventory/wms", module: "stock_ledger" },
  { prefix: "/inventory", module: "stock_ledger" },

  { prefix: "/purchase/requisition", module: "purchase_requisition" },
  { prefix: "/purchase/orders", module: "purchase_order" },
  { prefix: "/purchase/grn", module: "grn" },
  { prefix: "/purchase/ap-invoice", module: "ap_invoice" },
  { prefix: "/purchase/vendor-payment", module: "vendor_payment" },
  { prefix: "/purchase/gstr2b", module: "gstr2b" },
  { prefix: "/purchase/rfq", module: "rfq" },
  { prefix: "/purchase/reports", module: "purchase_reports" },
  { prefix: "/purchase/return", module: "purchase_return" },
  { prefix: "/purchase/three-way-match", module: "three_way_match" },
  { prefix: "/purchase", module: "purchase_order" },

  { prefix: "/sales/delivery", module: "delivery" },
  { prefix: "/sales/dispatch-scan", module: "dispatch_scan" },
  { prefix: "/sales/ar-invoice", module: "ar_invoice" },
  { prefix: "/sales/einvoice", module: "einvoice" },
  { prefix: "/sales/eway-bill", module: "eway_bill" },
  { prefix: "/sales/credit-management", module: "credit_management" },
  { prefix: "/sales/payment-followup", module: "payment_followup" },
  { prefix: "/sales/customer-payment", module: "customer_payment" },
  { prefix: "/sales/sale-tracker", module: "sale_tracker" },
  { prefix: "/sales/quotations", module: "sales_quotation" },
  { prefix: "/sales/returns", module: "sales_return" },
  { prefix: "/sales/battery-buyback", module: "battery_buyback" },
  { prefix: "/sales/warranty-claims", module: "warranty_claims" },
  { prefix: "/sales/targets", module: "sales_targets" },
  { prefix: "/serial/dashboard", module: "serial_dashboard" },
  { prefix: "/serial/register", module: "serial_register" },
  { prefix: "/serial/recycling", module: "recycling_batches" },
  { prefix: "/serial", module: "sales_order" },
  { prefix: "/sales", module: "sales_order" },
  { prefix: "/crm", module: "sales_order" },
  { prefix: "/dealer", module: "sales_order" },
  { prefix: "/portal-admin", module: "sales_order" },
  { prefix: "/service", module: "sales_order" },

  { prefix: "/production/bom", module: "bom" },
  { prefix: "/production/grid-plate", module: "grid_plate_production" },
  { prefix: "/production/spine-plate", module: "spine_plate_production" },
  { prefix: "/production/battery-assembly", module: "battery_assembly" },
  { prefix: "/production/barcode", module: "barcode_labels" },
  { prefix: "/production/mrp-workbench", module: "mrp_workbench" },
  { prefix: "/production/mrp", module: "mrp_planning" },
  { prefix: "/production/plate-stock", module: "plate_stock" },
  { prefix: "/production/battery-stock", module: "battery_stock" },
  { prefix: "/production/wip", module: "production" },
  { prefix: "/production", module: "production_order" },
  { prefix: "/qc", module: "production_order" },
  { prefix: "/pm", module: "production_order" },
  { prefix: "/oee", module: "production_order" },
  { prefix: "/hazmat", module: "production_order" },
  { prefix: "/sfc-admin", module: "production_order" },
  { prefix: "/sfc-terminal", module: "production_order" },
  { prefix: "/sfc", module: "production_order" },

  { prefix: "/finance/coa", module: "chart_of_accounts" },
  { prefix: "/finance/opening-balance", module: "chart_of_accounts" },
  { prefix: "/finance/gl-determination", module: "chart_of_accounts" },
  { prefix: "/finance/tax-master", module: "chart_of_accounts" },
  { prefix: "/finance/tds-report", module: "chart_of_accounts" },
  { prefix: "/finance/fixed-assets", module: "chart_of_accounts" },
  { prefix: "/finance/journal", module: "journal_entry" },
  { prefix: "/finance/bank-recon", module: "journal_entry" },
  { prefix: "/finance/recurring-je", module: "journal_entry" },
  { prefix: "/finance/period-close", module: "journal_entry" },
  { prefix: "/finance/periods", module: "journal_entry" },
  { prefix: "/finance/budget", module: "budget" },
  { prefix: "/finance/reports", module: "reports" },
  { prefix: "/finance/statement-of-account", module: "reports" },
  { prefix: "/finance/cash-flow", module: "reports" },
  { prefix: "/finance", module: "reports" },
  { prefix: "/mis", module: "reports" },
  { prefix: "/cost", module: "reports" },
  { prefix: "/bi", module: "reports" },
  { prefix: "/mc", module: "reports" },
  { prefix: "/workflow", module: "reports" },
  { prefix: "/dms", module: "reports" },
  { prefix: "/admin/mviews", module: "reports" },

  { prefix: "/hr/payroll-foundation", module: "payroll_foundation" },
  { prefix: "/hr/payroll-admin", module: "payroll_foundation" },
  { prefix: "/hr/payroll-sales", module: "payroll_foundation" },
  { prefix: "/hr/payroll-labour", module: "payroll_foundation" },
  { prefix: "/hr", module: "hr" },
  { prefix: "/users-legacy", module: "users" },
  { prefix: "/users", module: "users" },
  { prefix: "/admin/super-control", module: "platform_control" },
  { prefix: "/tools/tally", module: "users" },
  { prefix: "/projects", module: "users" },
  { prefix: "/admin/website-leads", module: "users" },
  { prefix: "/admin/monitor", module: "audit_log" },
  { prefix: "/admin/domain-control", module: "domain_control" },
  { prefix: "/admin/api-tokens", module: "users" },
  { prefix: "/admin/dropdowns", module: "platform_control" },

  { prefix: "/approvals", module: "approval" },
  { prefix: "/approval", module: "approval" },
  { prefix: "/audit-legacy", module: "audit_log" },
  { prefix: "/audit", module: "audit_log" },
  { prefix: "/notifications", module: "company_settings" },
  { prefix: "/settings", module: "company_settings" },
  { prefix: "/admin/custom-fields", module: "company_settings" },
  { prefix: "/print-designer", module: "company_settings" },
];

const sortedRules = [...rules].sort((a, b) => b.prefix.length - a.prefix.length);

function normalizePath(pathname: string): string {
  const clean = (pathname || "/").split("?")[0].split("#")[0].replace(/\/+$/, "");
  return clean || "/";
}

function matches(pathname: string, prefix: string): boolean {
  const path = normalizePath(pathname);
  const cleanPrefix = normalizePath(prefix);
  return path === cleanPrefix || path.startsWith(`${cleanPrefix}/`);
}

function selectedCompanyId(): string {
  try {
    return String(getOptionalSelectedCompanyId() ?? "default");
  } catch {
    return "default";
  }
}

function readRouteList(key: string): string[] | null {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || "null");
    return Array.isArray(parsed)
      ? parsed.filter((item: unknown) => typeof item === "string")
      : null;
  } catch {
    return null;
  }
}

function readDisabledRoutes(): string[] | null {
  const companyId = selectedCompanyId();
  return readRouteList(`erp_disabled_routes_${companyId}`);
}

function readCatalogRoutePermissions(): RoutePermission[] {
  try {
    const companyId = selectedCompanyId();
    const parsed = JSON.parse(localStorage.getItem(`erp_navigation_${companyId}`) || "[]");
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((row: any) => row && row.is_enabled !== false)
      .map((row: any) => ({
        prefix: typeof row.route_path === "string" ? normalizePath(row.route_path) : "",
        module: typeof row.permission_module === "string" && row.permission_module.trim()
          ? row.permission_module.trim()
          : String(row.module_code || "").trim(),
        action: (["view", "create", "edit", "delete", "approve"] as PermissionAction[])
          .includes(row.permission_action)
          ? row.permission_action
          : "view",
      }))
      .filter((row: RoutePermission) => !!row.prefix && !!row.module)
      .sort((a: RoutePermission, b: RoutePermission) => b.prefix.length - a.prefix.length);
  } catch {
    return [];
  }
}

export function isRouteFeatureEnabled(pathname: string): boolean {
  const disabledRoutes = readDisabledRoutes();
  if (!disabledRoutes || disabledRoutes.length === 0) return true;
  const path = normalizePath(pathname === "/" ? "/dashboard" : pathname);
  return !disabledRoutes.some((prefix) => matches(path, prefix));
}

export function getRoutePermission(pathname: string): Required<RoutePermission> | null {
  const catalogRules = readCatalogRoutePermissions();
  const match = catalogRules.find((rule) => matches(pathname, rule.prefix))
    || sortedRules.find((rule) => matches(pathname, rule.prefix));
  if (!match) return null;
  return {
    prefix: match.prefix,
    module: match.module,
    action: match.action || "view",
  };
}
